declare var _INITIALIZE_LOCATION_SEARCH_: string | void;
declare var chrome: any | void;

if (process.env.NODE_ENV !== "test" && typeof _INITIALIZE_LOCATION_SEARCH_ !== "string") {
  const shouldShowError =
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    // In Electron preload `document` exists but not `document.body`
    document.body != null &&
    typeof window.location !== "undefined" &&
    // Check if inside chrome extenstion
    !(typeof chrome !== "undefined" && chrome.runtime && chrome.runtime.id != null);

  if (shouldShowError) {
    throw new ReferenceError(
      "_INITIALIZE_LOCATION_SEARCH_ wasn't initialized which means some FEATURES might won't work",
    );
  }
}

const locationSearch: string = typeof _INITIALIZE_LOCATION_SEARCH_ === "string" ? _INITIALIZE_LOCATION_SEARCH_ : "";

const searchParams: Map<string, string> = parseLocationSearch(locationSearch);

const REACT_APP_FEATURE_HTTP_SYNC_ONLY = process.env.REACT_APP_FEATURE_HTTP_SYNC_ONLY;
const REACT_APP_FEATURE_LOG_ANALYTICS = process.env.REACT_APP_FEATURE_LOG_ANALYTICS;
const REACT_APP_FEATURE_NO_LOADER = process.env.REACT_APP_FEATURE_NO_LOADER;

const HTTP_SYNC_ONLY = isTrue(REACT_APP_FEATURE_HTTP_SYNC_ONLY) || isTrue(searchParams.get("HTTP_SYNC_ONLY"));
const HAS_API_HOST =
  (searchParams.has("API_HOST") && searchParams.has("WS_API_HOST")) || (HTTP_SYNC_ONLY && searchParams.has("API_HOST"));

if (!HAS_API_HOST && searchParams.has("API_HOST")) {
  // eslint-disable-next-line no-console
  console.info(
    `%c ✔︎ %c  %s`,
    "background-color: #0da5f3; color: white",
    "background-color: unset; color: unset",
    "You should always use `API_HOST` and `WS_API_HOST` together or `API_HOST` and `HTTP_SYNC_ONLY`",
  );
}

//#region FEATURES
/** Allow only HTTP sync and doesn't use WebSocket */
export const FEATURE_HTTP_SYNC_ONLY = HTTP_SYNC_ONLY;
/** Log to dev tools analytics events */
export const FEATURE_LOG_ANALYTICS =
  isTrue(REACT_APP_FEATURE_LOG_ANALYTICS) || isTrue(searchParams.get("LOG_ANALYTICS"));
/** Is Google / Facebook login by pop-up or by redirect? */

/** Don't show loader for initial sync */
export const FEATURE_NO_LOADER = isTrue(REACT_APP_FEATURE_NO_LOADER) || isTrue(searchParams.get("NO_LOADER"));

export const FEATURE_NO_AB_EXPERIMENTS = isTrue(searchParams.get("NO_AB_EXPERIMENTS"));
export const FEATURE_NO_INDXEDDB = isTrue(searchParams.get("NO_INDXEDDB"));
export const FEATURE_FORCE_CRASH = isTrue(searchParams.get("FORCE_CRASH"));

/** Are task title shown event when it's duplicated with toolbar title */
export const FEATURE_TASK_LIST_AUTO_HIDE = true;

/** Suppress automatic timezone update for user https://anydo1.atlassian.net/browse/WEB4-312*/
export const FEATURE_SUPPRESS_TIMEZONE_UPDATE = isTrue(searchParams.get("SUPPRESS_TIMEZONE_UPDATE"));

export const FEATURE_BOARD_AUTOMATIONS_PROMPT_UI = isTrue(searchParams.get("BOARD_AUTOMATIONS_PROMPT_UI"));
//#endregion

export const FEATURE_FORCE_VERSION_UPDATE_BANNER = isTrue(searchParams.get("FORCE_VERSION_UPDATE_BANNER"));

/**
 * Helpers
 */

function isTrue(flag?: string | null): boolean {
  return flag === "1";
}

function parseLocationSearch(search: string): Map<string, string> {
  const searchParams = new URLSearchParams(search);
  const params = new Map<string, string>();
  const FEATURE_SEARCH_PARAM_RE = /^FEATURE_(.+)$/;

  searchParams.forEach((value, key) => {
    const result = FEATURE_SEARCH_PARAM_RE.exec(key);

    if (result != null) {
      const flag = result[1];
      params.set(flag, value);
    }
  });

  return params;
}
